// extracted by mini-css-extract-plugin
export default {"leave":"leave-page_leave__4NOks","title":"leave-page_title__2CdbV","desc":"leave-page_desc__QU3fo"};